module.exports = __webpack_public_path__ + "static/south_pointe-6653c0f7ceb2c39ce746a39ff3815ed9.png";